"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpProxyLoader = void 0;
const operators_1 = require("rxjs/operators");
function createHttpProxyLoader(proxy) {
    return function httpProxyLoader(modelValue, loadPayload) {
        return proxy
            .load(null, Object.assign(Object.assign({}, modelValue), loadPayload.params), loadPayload.filterQuery)
            .pipe((0, operators_1.map)((value) => ({
            data: value.data,
            meta: { totalCount: value.meta.totalCount, status: value.meta.status }
        })));
    };
}
exports.createHttpProxyLoader = createHttpProxyLoader;
//# sourceMappingURL=loader.js.map